import React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import {
    BlockContainer,
    BlockCta,
    BlockDescription,
    BlockHeader,
} from "src/components/ContinueDealerOffer/PageComponents/Blocks";
import { PageContent } from "src/components/ContinueDealerOffer/PageComponents/PageContent";
import { PageHeader } from "src/components/ContinueDealerOffer/PageComponents/PageHeader";
import CustomOffer from "src/components/icons/CustomOffer";
import Signature from "src/components/icons/Signature";
import { ApplicationStore } from "src/store";

const IndexPage = ({ name, hasSignatures }: ReturnType<typeof mapStateToProps>) => {
    const history = useHistory();
    const { t } = useTranslation();

    return (
        <PageContent>
            <PageHeader>
                {name
                    ? t("DealerOffer.ContinueDealerOffer.IndexPage.PersonalizedHeader", { name })
                    : t("DealerOffer.ContinueDealerOffer.IndexPage.Header")}
            </PageHeader>

            <BlockContainer icon={<CustomOffer />}>
                <BlockHeader>{t("DealerOffer.ContinueDealerOffer.IndexPage.ReviewBlock.Header")}</BlockHeader>
                <BlockDescription>
                    {t("DealerOffer.ContinueDealerOffer.IndexPage.ReviewBlock.Description")}
                </BlockDescription>
                <BlockCta
                    label={t("DealerOffer.ContinueDealerOffer.IndexPage.ReviewBlock.CTA")}
                    handleClick={() => history.push(`/dealer-offer/review`)}
                />
            </BlockContainer>

            {hasSignatures && (
                <BlockContainer icon={<Signature />}>
                    <BlockHeader>{t("DealerOffer.ContinueDealerOffer.IndexPage.SignatureBlock.Header")}</BlockHeader>
                    <BlockDescription>
                        {t("DealerOffer.ContinueDealerOffer.IndexPage.SignatureBlock.Description")}
                    </BlockDescription>
                </BlockContainer>
            )}
        </PageContent>
    );
};

const mapStateToProps = (state: ApplicationStore) => ({
    name: state.deal.person?.first_name,
    hasSignatures: state.hasSignatures,
});

export default connect(mapStateToProps)(IndexPage);
